import * as uuid from "uuid";

import EventManager from "../../store/sqftEventManager";
import {FREE_DRAW_TYPE, SIDEBAR_BUTTONS_MENU, SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../../../constants";
import RenderFreeDraw from "../../helpers/renderFreeDraw";
import {COLORS} from "../../../../../../colorThemes";
import NumberText from "../workspace/text/numberText";
import workspace from "../workspace";
import {getPointField} from "../../../../helpers/sqftHelper";
import eventManager from "../../store/sqftEventManager";
import store from "../../../../../../store";
import {getWallLockedPoint} from "../../helpers/wallHelper";
import {isPointInsidePolygon} from "../../../../lib/pnpoly";
import {getBordersOfTwoPoints, getLineBordersArrayV2} from "../../helpers/lineHelper";
import workspaceControllers from "../../store/workspaceControllers";

export default class Wall {
  dimensionToMouse = null;
  id;
  state = {
    addedPoints: [],
    dimensions: [],
    drawLineToMouse: false,
    lineThickness: 10,
    lineColor: COLORS.gray,
    outlineColor: COLORS.gray4,
    minLineLength: 15,
    drawType: FREE_DRAW_TYPE.wall,
    isHovering: false,
    mouseDown: false,
    mouseDownPosition: null,
    lockedAngleStep: 45,
  };
  editState = {
    editPoint: null,
    isInEditState: false,
  }

  getPoints() { return this.state.addedPoints }
  setEditMode(value) { this.editState.isInEditState = value}
  setEditPoint(point) { this.editState.editPoint = point}
  getOffset() { return workspace.getOffset() }
  getWallThickness() { return workspace.getOffset() }

  constructor(points, centerPoint, lockedAngleStep = 45) {
    this.id = uuid.v4();
    this.state.addedPoints = points
    this.state.centerPoint = centerPoint
    this.state.lockedAngleStep = lockedAngleStep
    this.initEvents();
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      EventManager.priorities.WALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown.bind(this),
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove.bind(this),
      this,
      EventManager.priorities.SEGMENT
    );
  }

  export() {
    return {
      "addedPoints": this.state.addedPoints.map(point => point.exportData ? point.exportData() : null),
      "centerPoint": this.state.centerPoint,
      "lockedAngleStep": this.state.lockedAngleStep,
    }
  }

  destroy() {
    this.deregisterEvents();
    this.destroyPoints();
  }

  destroyPoints() {
    for (const addedPoints of this.state.addedPoints) {
      addedPoints.destroy()
    }
  }

  deregisterEvents() {
    eventManager.removeEvent(this);
  }

  editWall(point) {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
      this.setEditMode(true);
      this.setEditPoint(point);
    }
  }

  disableEditingWall() {
    this.setEditMode(false);
    this.setEditPoint(null);
  }

  createDimensionToMouse() {
    this.dimensionToMouse = new NumberText(
      0,
      {x: 0, y: 0},
      {shouldRenderFrameBorder: true, isLength: true},
      workspace,
      Function(),
      true
    );
  }

  onMouseDown(mousePos) {
    if (this.editState.editPoint && this.editState.isInEditState) {
      this.addPoint(mousePos);
      this.disableEditingWall();
      return true
    }
    if (this.state.isHovering) {
      const reduxState = store.getState();
      if (reduxState.sqftMenuState.activeButton === SIDEBAR_BUTTONS_MENU.delete) {
        workspaceControllers.walls.destroyResource(this)
      }
    }
  }

  onMouseMove(mousePos) {
    this.state.isHovering = this.isMouseOverWall(mousePos) || this.state.mouseDown;
  }

  isMouseOverWall(mousePos) {
    for (const addedPointKey in this.state.addedPoints) {
      const nextPoint = this.state.addedPoints[+addedPointKey +1];
      if (nextPoint) {
        const currentPoint = this.state.addedPoints[+addedPointKey];
        const lineFieldArray = getLineBordersArrayV2(currentPoint, nextPoint, this.state.lineThickness + this.state.lineThickness * 0.1);
        if (isPointInsidePolygon(mousePos, lineFieldArray)) {
          return true
        }
      }
    }
    return false
  }

  addPoint(mousePos) {
    const wallLockedPoint = getWallLockedPoint(this.editState.editPoint, mousePos, this.state.lockedAngleStep);
    if (this.state.addedPoints.length > 0) {
      //todo
      //this.addLineDimensions(point, mousePos);
    }
    if (this.editState.editPoint.id === this.state.addedPoints[0].id) {
      this.state.addedPoints.unshift(wallLockedPoint);
    } else {
      this.state.addedPoints.push(wallLockedPoint);
    }
  }

  getLines() {
    let lines = [];
    const points = this.getPoints();
    for (const pointIndex in points) {
      const len = points.length;
      const current = points[+pointIndex];
      //const previous = points[(pointIndex + len - 1) % len];
      const next = points[(pointIndex + 1) % len];
      let line = {
        from: current,
        to: next,
        getOffset: () => {
          return this.getOffset()
        }
      }
      lines.push(line);
    }

    return lines
  }

  getBordersOfWallLines() {
    let virtualLines = [];
    const points = this.getPoints();
    for (const addedPointKey in points) {
      const nextPoint = points[+addedPointKey +1];
      if (nextPoint) {
        const currentPoint = points[+addedPointKey];
        virtualLines.push(...getBordersOfTwoPoints(currentPoint, nextPoint, this.state.lineThickness / 2));
      }
    }
    return virtualLines
  }

  render(ctx) {
    ctx.save();
    this.renderLines(ctx);
    ctx.restore();
    //this.updateDimensionToMouse(ctx);
    if (this.editState.editPoint && this.editState.isInEditState) {
      RenderFreeDraw.drawLineFromPointV2ToMouse(ctx, this.editState.editPoint, true);
    }
  }

  renderLines(ctx) {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    ctx.lineWidth = this.state.lineThickness + 2;
    ctx.strokeStyle = this.state.outlineColor;
    RenderFreeDraw.renderLinesBetweenPoints(ctx, this.state);

    ctx.lineWidth = this.state.lineThickness;
    ctx.strokeStyle = this.state.isHovering && activeButton === SIDEBAR_BUTTONS_MENU.delete
      ? COLORS.red
      : this.state.lineColor;
    RenderFreeDraw.renderLinesBetweenPoints(ctx, this.state);
  }

  renderDimensionToMouseFromPoint = (ctx, point) => {
    let posX = point.modelCorePoint.mixins.movable.posX;
    let posY = point.modelCorePoint.mixins.movable.posY;
    let pointField = getPointField(posX, posY);
    ctx.moveTo(pointField.x, pointField.y);

    const mPos = EventManager.LastKnownMousePos;
    ctx.lineTo(mPos.x, mPos.y);
    ctx.stroke();
    ctx.closePath();
  }
}
